"use strict";
exports.__esModule = true;
exports.SvgSymbolMoney = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgSymbolMoney = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 9 16", fill: "none" }, props),
    react_1["default"].createElement("path", { d: "M8.74 10.97c.01-1.27-.49-2.27-1.49-2.98-.77-.54-1.7-.83-2.61-1.1-1.88-.57-2.43-.87-2.43-1.77 0-1.01 1.31-1.36 2.42-1.36.82 0 1.75.25 2.33.62L8.12 2.6c-.76-.49-1.8-.83-2.83-.93V0H3.16v1.78C1.27 2.2.08 3.43.08 5.12c0 1.18.49 2.11 1.46 2.77.73.5 1.62.77 2.49 1.04 1.85.55 2.6.9 2.59 2.02v.01c0 .95-1.26 1.28-2.33 1.28-1.02 0-2.12-.44-2.75-1.1L0 12.6c.79.84 1.94 1.43 3.16 1.66V16h2.13v-1.7c2.1-.3 3.45-1.57 3.45-3.33z", fill: "currentColor" }))); };
//# sourceMappingURL=SymbolMoney.js.map